import { WebDisMetadata } from '@m43/core';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { globalAttributes } from '../common/global-attributes';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useUnitAssignment } from '../unit-assignment/unit-assignment-context';
import { useActingUserHasDexDeviceOverride } from './use-acting-user-has-dex-device-override';
import { useDexMetadata } from './use-dex-metadata';

export function useShowDexDeviceIdentificationError(): boolean {
    const { dexRegion } = useBootstrapState();
    const { isFirstResponder, isWeb, isElectron } = useApplicationType();
    const unitAssignment = useUnitAssignment();
    const { dexMockModeEnabled } = useEnabledFeatures();
    const { dexMetadata, isLoading: isDexMetadataLoading } = useDexMetadata();
    const {
        hasDexDeviceOverride,
        isLoading: isHasDexDeviceOverrideLoading,
    } = useActingUserHasDexDeviceOverride({
        bypassCheck: isElectron || dexMockModeEnabled || !dexRegion || dexRegion === 'LA_LLETS',
    });
    if (
        isFirstResponder &&
        unitAssignment?.unitAgencyTypeGlobalAttrId !== globalAttributes.agencyTypeGlobal.POLICE
    ) {
        return false;
    }
    return (
        !!dexRegion &&
        isWeb &&
        !dexMockModeEnabled &&
        !isDexMetadataLoading &&
        !(dexMetadata as WebDisMetadata)?.machineName &&
        !isHasDexDeviceOverrideLoading &&
        !hasDexDeviceOverride &&
        dexRegion !== 'LA_LLETS'
    );
}
